import React, {useState, useEffect } from 'react';
export default function Notificator(props) {

    return (
        <div className={props.className}>{props.children}</div>
    );
}
